/** Shared constants for the assistant surfaces (docs/13, docs/15, docs/24). */

/** Public privacy policy — linked from the consent gate and the standing disclosure line
 *  (docs/15-ai-consent-privacy.md C4). */
export const PRIVACY_URL = 'https://steward.crossmarc.com/privacy';

/** Usage-meter thresholds: soften the bar at 80%, warn harder at 95% (docs/13 D5). */
export const WARN_AT = 0.8;
export const NEAR_LIMIT_AT = 0.95;

/** Starter questions shown on an empty chat — one per capability (figures,
 *  documents, product help) so new users see the assistant's range. */
export const SUGGESTIONS = [
  "What's my net worth?",
  'Which documents do I have on file?',
  'How do I connect a bank account?',
];

/** The same, in an advisory firm's own workspace (steward-app#1815): one per thing the firm
 *  assistant can see (clients, prospects, the team). No dashes, per the copy rules. */
export const FIRM_SUGGESTIONS = [
  'Which clients have we added recently?',
  'Who is waiting on us in Prospects?',
  'Who is on our team?',
];

/**
 * How long the browser waits for `POST /assistant/query`. The default for every other call is
 * 15 s (`REQUEST_TIMEOUT_MS` in api/client.ts), but this route is allowed to run longer: the
 * server lets the model work for up to about 25 s inside a 28 s request deadline, and API
 * Gateway's HTTP API cuts any integration off at 30 s (steward-app#2541). 32 s outlasts that
 * ceiling by a margin, so the browser never reports a failure for an answer the server was
 * still about to deliver (and bill). If the server's limits move, move this with them.
 */
export const ASSISTANT_QUERY_TIMEOUT_MS = 32_000;

/**
 * How long a Stop's `POST /assistant/query/cancel` may take (docs/41 §5.2 (b)). Nothing waits on
 * it, so this only bounds a stalled socket. The server's own store write is bounded at 2 s with
 * one retry (`services/assistantCancel.ts`), so 10 s outlasts it with room for a cold start.
 */
export const ASSISTANT_CANCEL_TIMEOUT_MS = 10_000;
